import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/analytics";

export const NAV_LINKS = [
  { label: "How It Works", id: "how-it-works" },
  { label: "Role Suites", id: "role-suites" },
  { label: "Impact & ROI", id: "impact" },
  { label: "Security (Zero PHI)", id: "security" },
  { label: "Pricing", id: "pricing" },
  { label: "FAQ", id: "faq" },
];

export function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const go = (e, id) => {
    e.preventDefault();
    setMobileOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-200/60 bg-white/85 backdrop-blur-xl" data-testid="site-nav">
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-7 xl:flex" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              onClick={(e) => go(e, l.id)}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-navy"
            >
              {l.label}
            </a>
          ))}
          <button
            type="button"
            data-testid="nav-get-started-button"
            onClick={(e) => go(e, "pricing")}
            className="rounded-full bg-teal-600 px-5 py-2.5 font-display text-sm font-semibold text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-teal-700 hover:shadow-lg focus-visible:ring-2 focus-visible:ring-teal-600 focus-visible:ring-offset-2"
          >
            Get Started
          </button>
        </nav>
        <button
          type="button"
          className="rounded-md p-2 text-navy xl:hidden"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
          data-testid="nav-mobile-toggle"
          onClick={() => setMobileOpen((v) => !v)}
        >
          {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {mobileOpen && (
        <nav className="border-t border-slate-200/60 bg-white/95 px-4 pb-6 pt-3 backdrop-blur-xl xl:hidden" aria-label="Mobile" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={(e) => go(e, l.id)}
                className="rounded-md px-3 py-3 text-base font-medium text-slate-700 transition-colors hover:bg-slate-100"
              >
                {l.label}
              </a>
            ))}
            <button
              type="button"
              data-testid="nav-mobile-get-started-button"
              onClick={(e) => go(e, "pricing")}
              className="mt-3 rounded-full bg-teal-600 px-5 py-3 font-display text-base font-semibold text-white shadow-md transition-colors hover:bg-teal-700"
            >
              Get Started
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
